
//Shaher Yar 01/11/2022
import React, { useState } from 'react';
export default function CustomPager({
    onPageChangeRequest,
    pagedResult
}) {
    var res = pagedResult;
    const [pageNo, setPage] = useState(res.currentPage == null ? 1 : res.currentPage);
    const requestPageChange = (page) => {
        if (page < 1 || page > res.totalPages) {
            return;
        }
        onPageChangeRequest(page);
    }
    const onPageChange = (page) => {
        setPage(page);
        requestPageChange(page);
    }
  
    if (res == null || res.totalCount == 0 || res.totalPages == 0) {
        return <span />;
    }
    let CurrentPage = <input style={{ width: '60px', marginLeft: '5px' }}
        type="number" id="pager"
        name='pager'
        min="1"
        max={res.totalPages}
        value={pageNo}
        onChange={e => onPageChange(e.target.value)} />
    return (
        <>
            <div>
                <button type='button' className='btn btn-primary btn-sm' disabled={res.currentPage == 1 ? true : false} onClick={() => onPageChange(res.currentPage - 1)}> {"<"}</button>
                {CurrentPage} / {res.totalPages} of {res.totalCount} { }
                <button type='button' className='btn btn-primary btn-sm' style={{ marginRight: '5px !important' }} disabled={res.totalPages == res.currentPage ? true : false} onClick={() => onPageChange(res.currentPage + 1)}>{">"}</button>
            </div>
        </>
    )
}
